import axios from "axios";


export const deleteOrder = async (orderId) => {
  try {
    const response = await fetch(`/orders/${orderId}`, {
      method: "DELETE",
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Failed to delete order");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting order:", error);
  }
}

export const cancelOrder = async (orderId, refreshOrders) => {
    if (!window.confirm("Are you sure you want to cancel this order?")) return;
  
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/cancel-order/${orderId}`,
        {},
        { withCredentials: true }
      );
      if (res.status !== 200) {
        throw new Error("Failed to cancel order");
      }
      alert("Order cancelled successfully!");
      refreshOrders();
    } catch (err) {
      console.error("Error cancelling order:", err);
    }
  };

  export const downloadReceipt = async (orderId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/orders/${orderId}/receipt`, {
            method: "GET",
            credentials: "include",
        });
        if (!response.ok) throw new Error("Failed to download receipt");

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Receipt.pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } catch (error) {
        alert("Error downloading receipt");
    }
};

  